import store from '@/packages/vuex'
import { createNamespacedHelpers } from 'vuex'
import WebSocket from './index.js'

if (!store?.state?.['WebSocket']) {
	store.registerModule('WebSocket', WebSocket)
}

export const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers('WebSocket')
